import nxModule from 'nxModule';
import systemPropertyService from '../../../../react/system/systemPropertyService';
import statusService from '../../../../react/management/statusService';

class UserIdleCheck {
  constructor(authentication, $timeout, notification) {
    this.authentication = authentication;
    this.$timeout = $timeout;
    this.notification = notification;
    this.loggedOut = false;
    this.lastActivityTime = Date.now();
    this.events = ['mousedown', 'keydown', 'keypress', 'click', 'touchmove', 'wheel'];

    const idleTimePropValue = systemPropertyService.getProperty('USER_IDLE_TIME_MINUTES');
    this.userIdleTime = idleTimePropValue ? parseInt(idleTimePropValue) : 0;

    this.activityHandler = () => this.resetTimer();
    for (let event of this.events) {
      document.addEventListener(event, this.activityHandler, {passive: true});
    }

    this.statusCallback = (status) => {
      if (status.idleTimeoutMinutes != null && status.idleTimeoutMinutes !== this.userIdleTime) {
        this.userIdleTime = status.idleTimeoutMinutes;
        this.rescheduleTimer();
      }
    };
    this.unsubscribeStatus = statusService.registerForStatusUpdate(this.statusCallback);

    this.resetTimer();
  }

  $onDestroy() {
    this.stopTimer();
    if (this.unsubscribeStatus) {
      this.unsubscribeStatus();
    }
    for (let event of this.events) {
      document.removeEventListener(event, this.activityHandler);
    }
  }

  startTimer() {
    if (this.userIdleTime !== 0 && !this.loggedOut) {
      this.timeoutP = this.$timeout(() => {
        this.logoutDueToInactivity();
      }, this.userIdleTime * 60 * 1000);  // property value in minutes
    }
  }

  resetTimer() {
    this.lastActivityTime = Date.now();
    this.stopTimer();
    this.startTimer();
  }

  rescheduleTimer() {
    this.stopTimer();
    if (this.userIdleTime === 0 || this.loggedOut) {
      return;
    }
    const elapsed = Date.now() - this.lastActivityTime;
    const remaining = this.userIdleTime * 60 * 1000 - elapsed;
    if (remaining <= 0) {
      this.logoutDueToInactivity();
    } else {
      this.timeoutP = this.$timeout(() => {
        this.logoutDueToInactivity();
      }, remaining);
    }
  }

  logoutDueToInactivity() {
    this.notification.show('Logged out due to inactivity');
    console.info('Logged out due to inactivity');
    this.loggedOut = true;
    this.authentication.logoutAndKeepPath('Logged out due to inactivity');
  }

  stopTimer() {
    if (this.timeoutP) {
      this.$timeout.cancel(this.timeoutP);
      this.timeoutP = null;
    }
  }
}

nxModule.component('userIdleCheck', {
  controller: UserIdleCheck,
});
